

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n  ", h('circle', {"cx":"7.5","cy":"7","r":"7","fill":"#7A7A7A"}, []), "\n  ", h('path', {"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.7 9.083c0 .138.112.25.25.25h3.1a.25.25 0 0 0 .25-.25V6.368a.25.25 0 0 0-.064-.168L7.93 4.75a.25.25 0 0 0-.186-.083H5.95a.25.25 0 0 0-.25.25v4.166ZM4.5 3.792v6.416c0 .161.134.292.3.292h5.4c.166 0 .3-.13.3-.292V5.943a.287.287 0 0 0-.074-.192L8.49 3.6a.304.304 0 0 0-.226-.1H4.8c-.166 0-.3.13-.3.292Z","fill":"#fff"}, []), "\n"]);
};

        